var render, staticRenderFns
import script from "./KSelect.vue?vue&type=script&lang=js"
export * from "./KSelect.vue?vue&type=script&lang=js"
import style0 from "./KSelect.vue?vue&type=style&index=0&id=2f73e9d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73e9d1",
  null
  
)

export default component.exports